// extracted by mini-css-extract-plugin
export default {"form":"StudentMariContactModal_form__tZ5wJ"};